import React from 'react';
import MultiStepForm from './pages/MultiSpetForm';

function App() {
  return (
    <div className="App">
      <MultiStepForm />
    </div>
  );
}

export default App;